import { useEffect, useState } from "react";
import styles from "./notification.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import NotificationCard from "./components/NotificationCard";
import NotificationFilter from "./components/NotificationFilter";
import { TableLoader } from "../../../../../components/LoaderC";
import { TablePagination } from "@mui/material";
import moment from "moment";


const Notification = ({ tenant_id, setLoading, setSnackbarOpen, setSnackbarMsg }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [contentLoading, setContentLoading] = useState(true);
    const [notificationList, setNotificationList] = useState([]);
    const [allNotificationList, setAllNotificationList] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [filterData, setFilterData] = useState({ searchKey: "", date: null });

    useEffect(() => {
        const getNotificationList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios.get(process.env.REACT_APP_TENANT_API_URL + "v1/email-notifications/" + tenant_id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);
                setAllNotificationList(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        }
        if (tenant_id) {
            getNotificationList();
        }
    }, [tenant_id, getAccessTokenSilently]);

    useEffect(() => {
        let allNotificationListTemp = allNotificationList;

        if (filterData.searchKey !== "") {
            let inputVal = filterData.searchKey.toLowerCase();

            allNotificationListTemp = allNotificationListTemp.filter((item) => {
                const subjectMatch = item?.subject?.toLowerCase().includes(inputVal);
                const categoryMatch = item?.category?.toLowerCase().includes(inputVal);

                return (subjectMatch || categoryMatch);
            });
        }

        if (filterData.date) {
            allNotificationListTemp = allNotificationListTemp.filter((i) => {
                var dateR = filterData.date;
                if (moment(moment(i.sent_at).format("YYYY-MM-DD")).isBetween(moment(dateR[0]).format("YYYY-MM-DD"), moment(dateR[1]).format("YYYY-MM-DD"), undefined, [])
                ) {
                    return true;
                }
                return false;
            });
        }

        setNotificationList(allNotificationListTemp);
    }, [allNotificationList, filterData]);

    return <>
        {contentLoading && (<div className="Loader TableLoader">
            <TableLoader />
        </div>)}

        {!contentLoading && <>
            <NotificationFilter filterData={filterData} setFilterData={setFilterData.bind(this)} />

            <div className={`${styles.RentRollListSec}`}>
                <div className="FormAccording TenantDetails Theme Shadow">

                    {notificationList?.map((item, index) => {
                        return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<NotificationCard item={item} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} />) : null;
                    })}

                    {notificationList.length > 0 && (<div className="Pagination TablePaginationNew List">
                        <TablePagination
                            count={notificationList.length}
                            color="primary"
                            page={page}
                            rowsPerPage={perPage}
                            onPageChange={(e, v) => setPage(v)}
                            rowsPerPageOptions={[
                                { label: "10", value: 10 },
                                { label: "25", value: 25 },
                                { label: "100", value: 100 },
                                { label: "All", value: -1 },
                            ]}
                            onRowsPerPageChange={(e) => {
                                setPage(0);
                                setPerPage(e.target.value);
                            }}
                            labelRowsPerPage={"Notification per Page:"}
                        />
                    </div>)}

                    {notificationList.length === 0 && (<div className={`${styles.NoDataMain}`}>
                        <div className={`${styles.NoDataIMG}`}>
                            <img src="/static/img/no-notification.svg" alt="No Data" />
                        </div>
                        <p className={`${styles.NoDataText}`}>Check back later for updates!</p>
                        <p className={`${styles.NoDataTextSub}`}>Notification List is Currently Empty.</p>
                    </div>)}

                </div>
            </div>
        </>}
    </>
}

export default Notification;